import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { RoleService } from 'src/app/Service/Role/Role.service';

@Component({
  selector: 'app-RoleList',
  templateUrl: './RoleList.component.html',
  styleUrls: ['./RoleList.component.scss']
})
export class RoleListComponent implements OnInit {

  Token: string = ""
  Filter_Title: string = ""
  Filter_Fullname: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private Role_Service: RoleService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
  ) { }


  DataList_Role: Array<General_Interface> = []
  Role_Record_Delete: General_Interface = Empty_General_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2215).subscribe(
      data => {
        this.ReadData_Role()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }

  ReadData_Role() {
    this.Procssing = true
    this.Role_Service.GetRecord(this.Token,this.Filter_Fullname).subscribe(
      data => {
        this.DataList_Role = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  //#region Role Form

  Selected_Role_Record: General_Interface
  Selected_Role_Record_Switcher: string = 'List'
  Set_List_Role_View() {
    this.ReadData_Role()
    this.Selected_Role_Record_Switcher= 'List'
  }

  Set_Form_Role_View(item:General_Interface,Switcher:string) {
    this.Selected_Role_Record = item
    this.Selected_Role_Record_Switcher = Switcher
  }

  Set_Form_Role_View_Add() {
    this.Selected_Role_Record = Empty_General_Interface()
    this.Selected_Role_Record_Switcher = 'Form'
  }

  //#endregion

  //#region Delete

  Delete(){
    this.modalRef_Delete.hide()

    this.Role_Service.Delete(this.Token,this.Role_Record_Delete.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Deleted successfully.")
        this.ReadData_Role()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  DeleteModal(template: TemplateRef<any>,Record) {
    this.Role_Record_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  //#endregion

  Change_Filter() {
    this.page = 0
  }

}
